import React from 'react';
import { SelectRadioBox } from './SelectRadio.css';

const SelectRadio = () => {
  return (
    <SelectRadioBox>
      SELECT RADIO
    </SelectRadioBox>
  );
};

export default SelectRadio;